const queryToObject = (query = []) => {
    if (query.length < 2) {
        return {};
    }
    return query
        .slice(1)
        .split('&')
        .map((p) => p.split('='))
        .reduce((obj, [key, value]) => ({...obj, [key]: value}), {});
};

const objectToQuery = (obj) =>
    Object.keys(obj)
        .reduce((str, key) => `${str}&${key}=${obj[key]}`, '')
        .slice(1);

class URLSearchParamsPolyfill {
    // TODO remove URLSearchParamsPolyfill if we drop IE11 support
    constructor(search) {
        this.queryObj = queryToObject(search);
    }

    set(name, value) {
        this.queryObj[name] = value;
    }
    delete(name) {
        delete this.queryObj[name];
    }

    toString() {
        return objectToQuery(this.queryObj);
    }
}

const setQueryStringParameter = (name, value) => {
    if (typeof window === 'undefined' || !window.location || !window.history) {
        return;
    }

    const _URLSearchParams =
        typeof URLSearchParams === 'undefined' ? URLSearchParamsPolyfill : URLSearchParams;

    const params = new _URLSearchParams(window.location.search);
    if (!value) {
        params.delete(name);
    } else {
        params.set(name, value);
    }
    const queryString = `${decodeURIComponent(params)}`;
    const newURL = queryString
        ? `${window.location.pathname}?${queryString}`
        : window.location.pathname;
    window.history.replaceState({}, '', newURL);
};

module.exports = {
    queryToObject,
    objectToQuery,
    URLSearchParamsPolyfill,
    setQueryStringParameter
};
